import React, { useMemo } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TrustedBy from "../components/TrustedBy";
import DashboardMock from "../components/DashboardMock";
import HowItWorks from "../components/HowItWorks";
import Features from "../components/Features";
import Integrations from "../components/Integrations";
import SignalStories from "../components/SignalStories";
import FAQ from "../components/FAQ";
import CTA from "../components/CTA";
import Footer from "../components/Footer";
import SEO, { ORG_JSON_LD, softwareJsonLd } from "../components/SEO";

export default function HomePage() {
  // Memoized so a new object reference isn't created on every render
  // (avoids unnecessary <SEO> / Helmet rebuilds)
  const homeJsonLd = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@graph": [ORG_JSON_LD, softwareJsonLd()],
    }),
    []
  );

  return (
    <div className="min-h-screen bg-white antialiased">
      <SEO
        title="BuyerBeacon Pro — Find Ready Buyers in a Sea of Noise"
        description="Identify anonymous website visitors, score buyer intent, and activate across email and direct mail. 280M+ consumer profiles, 120M+ B2B contacts. Built for small business."
        path="/"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <Hero />
        <TrustedBy />
        <DashboardMock />
        <HowItWorks />
        <Features />
        <Integrations />
        <SignalStories />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
